import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { API_URL } from "../../constant/API_Settings";

/**
 * Polls auth/check-force-logout while the user has a session token.
 * When force_logout is set on the user row (e.g. during pump-wide approval), shows a message and logs out.
 */
const ForceLogoutPoller = () => {
	const history = useHistory();
	const pollRef = useRef(null);
	const handledRef = useRef(false);

	useEffect(() => {
		handledRef.current = false;

		const poll = () => {
			const token = localStorage.getItem("AUTH_TOKEN");
			if (!token || handledRef.current) return;

			const requestOptions = {
				method: "get",
				headers: {
					Authorization: "Bearer " + token,
					Accept: "application/json",
				},
			};

			fetch(API_URL + "/auth/check-force-logout", requestOptions)
				.then((response) => response.json())
				.then((data) => {
					if (
						data &&
						(data.force_logout === true ||
							data.force_logout === 1 ||
							data.force_logout === "1")
					) {
						if (handledRef.current) return;
						handledRef.current = true;
						if (pollRef.current) {
							clearInterval(pollRef.current);
							pollRef.current = null;
						}
						swal(
							"",
							"Approval process is started, please wait some time",
							"info"
						).then(() => {
							localStorage.removeItem("AUTH_TOKEN");
							history.push("/login");
						});
					}
				})
				.catch(() => {});
		};

		const pollMs =
			typeof window !== "undefined" &&
			(window.location.hostname === "localhost" ||
				window.location.hostname === "127.0.0.1") &&
			String(window.location.port) === "3000"
				? 30000
				: 30000;

		poll();
		pollRef.current = setInterval(poll, pollMs);

		return () => {
			if (pollRef.current) {
				clearInterval(pollRef.current);
				pollRef.current = null;
			}
		};
	}, [history]);

	return null;
};

export default ForceLogoutPoller;
